/*
 * Copyright (c) 2000-2022 TeamDev. All rights reserved.
 * TeamDev PROPRIETARY and CONFIDENTIAL.
 * Use is subject to license terms.
 */

import {LservVue} from '@/shell/LservVue';

/**
 * A base class for all views that helps implement common functionality.
 */
export default abstract class AbstractAppView extends LservVue {
  mounted(): void {
    this.updateViewTitle();
  }

  /**
   * Returns the title that should be displayed in the application bar when this view is active.
   * Should be implemented in subclasses.
   */
  protected abstract getViewTitle(): string;

  private updateViewTitle(): void {
    const title = this.getViewTitle();
    this.$store.commit('setViewTitle', {title});
  }
}
